import CalendarWeekNumbering from '../../../base/i18n/date/CalendarWeekNumbering.js';
export default CalendarWeekNumbering;